module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "time-to-let-her-rest-in-peace"
    }
  }, [_c('p', {
    staticStyle: {
      "text-align": "center",
      "padding-top": "90px",
      "font-size": "15pt",
      "padding-bottom": "30px"
    }
  }, [_vm._v("‘Time to Let Her Rest in Peace’")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0px"
    }
  }, [_c('br'), _vm._v("The mystery is this:")]), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0px"
    }
  }, [_vm._v("The more you go beyond yourself, the more you will become your true self.")]), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0px"
    }
  }, [_vm._v("The more you lose yourself in loving and serving others, the more you will find yourself.")]), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0px"
    }
  }, [_vm._v("The more you keep company with those who suffer, the more you will be healed.")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('ul', {
    staticStyle: {
      "list-style-type": "none",
      "text-indent": "0px"
    }
  }, [_c('li', [_vm._v("Rt Revd Richard Chartres, Bishop of London, speaking at the tenth anniversary of the death of Diana, Princess of Wales.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4a49197e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/ch006.vue
// module id = 78
// module chunks = 0